// const store = createStore(combineReducers({
//   loginReducer,
//   connexionReducer,
//   dashboardReducer,
//   comparisonReducer,
//   fullmapReducer,
//   trendsReducer,
//   settingsReducer,
//   temporalityReducer,
//   geographyReducer,
//   chartReducer,
//   mapReducer
// }));

/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import createReducer from "./reducers";

export default function configureStore(initialState = {}, history) {
  let composeEnhancers = compose;

  // If Redux Dev Tools and Saga Dev Tools Extensions are installed, enable them
  if (process.env.NODE_ENV !== "production" && typeof window === "object") {
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
    }
  }

  // Create the store with middlewares
  const middlewares = [routerMiddleware(history), thunk];

  // add logger in development
  // if (process.env.NODE_ENV === "development") {
  //   const { createLogger } = require("redux-logger");
  //   const logger = createLogger({
  //     collapsed: true,
  //     duration: true,
  //     diff: true,
  //   });
  //   middlewares.push(logger);
  // }

  const enhancers = [applyMiddleware(...middlewares)];

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(...enhancers)
  );

  window.store = store;

  // Extensions
  store.injectedReducers = {}; // Reducer registry

  // Activate hot reload for reducers, more in https://github.com/reduxjs/react-redux/issues/843
  if (module.hot) {
    module.hot.accept("./reducers", () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return store;
}
